(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brume-cart-extras"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__brumeCartShip) return;
    window.__brumeCartShip = true;
    function msg(h) {
      var now = new Date(), cut = new Date(now);
      cut.setHours(h, 0, 0, 0);
      var wd = now.getDay() !== 0 && now.getDay() !== 6;
      if (wd && now < cut) {
        var left = cut - now;
        return 'Commande dans les ' + Math.floor(left / 36e5) + ' h ' + (Math.floor(left / 6e4) % 60) + ' min : expédiée aujourd\u2019hui.';
      }
      return 'Expédiée au prochain jour ouvré.';
    }
    function upd() {
      document.querySelectorAll('[data-brume-cartship]').forEach(function (el) {
        var m = msg(parseInt(el.getAttribute('data-cutoff'), 10) || 14);
        if (el.textContent !== m) el.textContent = m;
      });
    }
    function start() {
      upd();
      var d = document.getElementById('cart-drawer');
      if (d) new MutationObserver(function () { window.requestAnimationFrame(upd); }).observe(d, { childList: true, subtree: true });
      setInterval(upd, 30000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__brumeUpgrade) return;
    window.__brumeUpgrade = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-brume-upgrade]');
      if (!b) return;
      b.disabled = true; b.textContent = 'Un instant…';
      var updates = {};
      updates[b.getAttribute('data-unit')] = 0;
      updates[b.getAttribute('data-cure')] = parseInt(b.getAttribute('data-qty'), 10) || 1;
      var root = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.href = root + 'cart'; })
        .catch(function () { b.disabled = false; b.textContent = 'Passer à la cure · 44,90 €'; });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
